module.exports = __webpack_public_path__ + "media/images/photos/photo-12-614ac001433638f48c2dca898d9cf5f1.jpg";